import React, { FC, useState } from 'react';
// components
import Button from '../../../Button';
import toast from '../../../../../../../components/Toast/dispatch';
import DeleteOverlayModal from './DeleteOverlayModal/DeleteOverlayModal';
import Tooltip from '../../../../../../../pages/Quotes/components/generics/Tooltip/Tooltip';
// assets
import closeModalIcon from 'img/closeModalIcon.svg';
// services
import QuoteServices from '../../../../../../../services/quote.service';
//models
import { IItemObservation } from '../../../../../../../models/portalModels/ItemObservation';
// styles
import './styles.scss';

const SupplierObsFieldModal: FC<any> = ({ handleCloseItemObsModal, setSupplierNote, setNotes, item, sequenceNumber, closeIcon }: any) => {
	const [charCount, setCharCount] = useState(0);
	const [displayOverlayModal, setDisplayOverlayModal] = useState(false);
	const [obsFieldText, setObsFieldText] = useState(sequenceNumber === undefined ? item.supplierNote : item.Notes);

	const handleCharCounter = (event: any) => {
		const input = event.target.value;
		if (charCount <= 4000) {
			setCharCount(input.length);
		}
		setObsFieldText(event.target.value);
	};
	const handleChoice = () => {
		if (displayOverlayModal)
			return (
				<div className="modal-container">
					<Tooltip
						areaRight='1%'
						areaBottom='3%'
						disable
						width={'368px'}
						height={'64px'}
						border={'1px solid #F9B609'}>
						<DeleteOverlayModal
							setDisplayOverlayModal={setDisplayOverlayModal}
							handleCloseItemObsModal={handleCloseItemObsModal}
						/>
					</Tooltip>
				</div>
			);
	};

	const saveObsSupplierFieldTextInfo = async () => {

		if (sequenceNumber) {
			const observationModel: IItemObservation = {
				itemObservation: obsFieldText
			};
			handleCloseItemObsModal();
			if (charCount > 0 || item.Notes) {
				await new QuoteServices().saveObsFieldText(
					item.quoteId,
					sequenceNumber,
					observationModel
				)
					.then(() => {
						setNotes(obsFieldText);
					})
					.catch((error) => {
						toast.error(`Não foi possível salvar as observações do fornecedor.
                        ${JSON.stringify(error?.response?.statusText)}`);
					});
			} else {
				return;
			}
		} else if (sequenceNumber === undefined) {
			const observationModel: IItemObservation = {
				itemObservation: obsFieldText
			};
			handleCloseItemObsModal();

			await new QuoteServices().saveObsFieldSupplierText(
				item.quoteId,
				observationModel
			)
				.then(() => {
					setSupplierNote(obsFieldText);
				})
				.catch((error) => {
					toast.error(`Não foi possível salvar as observações do fornecedor.
                    ${JSON.stringify(error?.response?.statusText)}`);
				});
		}
	};

	return (
		<div className="supplierObsFieldModal-container">
			<textarea
				value={obsFieldText}
				onChange={(e: any) => handleCharCounter(e)}
				name="obsField"
				placeholder={closeIcon ? "Adicione aqui as observações gerais da cotação." : "Adicione aqui as observações do item."}
				maxLength={4000}
				cols={30}
				rows={10}
			>
				{item.Notes}
			</textarea>
			<div className="charCount-container">
				{charCount !== 0 ?
					<div className="charCount" style={{ color: '#9F9F9F' }}>
						<span className="charCount--current-char">{charCount} de </span>
						<span className="charCount--maximum">4000</span>
					</div>
					:
					<div className="charCount"></div>
				}

				<div className="flex-end-position">
					<div style={{ marginRight: '8px' }}>
						{charCount > 0 ?
							<div>
								{handleChoice()}
								<Button width={80} label="Cancelar" onClick={() => setDisplayOverlayModal(true)} second ></Button>
							</div>
							:
							<Button width={80} label="Cancelar" onClick={handleCloseItemObsModal} second />
						}
					</div>
					{!item.Notes && charCount === 0 ?
						<Button className="disableBtn" width={80} label="Salvar" disable />
						:
						<Button width={80} label="Salvar" onClick={saveObsSupplierFieldTextInfo} />
					}

				</div>
			</div>
			{closeIcon &&
				<div className='modal-header-img'>
					{charCount !== 0 ?
						<img src={closeModalIcon} onClick={() => setDisplayOverlayModal(true)} />
						:
						<img src={closeModalIcon} onClick={handleCloseItemObsModal} />
					}
				</div>
			}
		</div>
	);
};

export default SupplierObsFieldModal;